import {gql, useMutation} from '@apollo/client';
import React from 'react';
import {ProgressPortraitFileType} from "./domain";

const CREATE_PROGRESS_PORTRAIT_FILE_DOWNLOAD_REQUEST = gql`
    mutation CreateProgressPortraitFileDownloadRequest($portraitGuid: String!, $fileType: String!) {
        createProgressPortraitFileDownloadRequest(portraitGuid: $portraitGuid, fileType: $fileType) {
            guid
            downloadUrl
        }
    }
`;

type FileDownloadRequestResponse = {
    guid: string;
    downloadUrl: string;
}

type Props = {
    portraitGuid: string;
    fileType: ProgressPortraitFileType;
    label: string;
}

export const ProgressPortraitDownloadLink = ({portraitGuid, fileType, label}: Props) => {
    const [createDownloadRequest, {loading}] = useMutation<{ createProgressPortraitFileDownloadRequest: FileDownloadRequestResponse }>(
        CREATE_PROGRESS_PORTRAIT_FILE_DOWNLOAD_REQUEST
    );

    const handleDownload = async () => {
        try {
            const {data} = await createDownloadRequest({
                variables: {portraitGuid, fileType}
            });
            const downloadUrl = data?.createProgressPortraitFileDownloadRequest?.downloadUrl;
            if (downloadUrl) {
                window.open(downloadUrl, '_blank', 'noopener');
            }
        } catch (err) {
            console.error('Failed to download progress portrait', err);
        }
    };

    return (
        <span
            className={`text-sm ${loading ? 'text-gray-400' : 'text-blue-portal-link cursor-pointer'}`}
            onClick={loading ? undefined : handleDownload}
        >
            {loading ? 'Loading...' : label}
        </span>
    );
};
